import useHomeStats from '../hooks/useHomeStats';

const renderRow = (row, index) => {
  if (row.columns) {
    return (
      <div className="stats-two-col" key={row.columns.map((column) => column.label).join('-') || index}>
        {row.columns.map((column) => (
          <div key={column.label} className="stats-col-item">
            <p className="stats-subrow-title">{column.label}</p>
            <p className="stats-subrow-value">{column.value}</p>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div key={row.label || index} className="stats-row-box">
      <p className="stats-subrow-title">{row.label}</p>
      <p className="stats-subrow-value">{row.value}</p>
    </div>
  );
};

function StatsGrid() {
  const { cards, loading } = useHomeStats();

  if (loading) {
    return (
      <section className="stats-grid" aria-busy="true">
        {Array.from({ length: 4 }, (_, index) => (
          <article key={index} className="stats-card stats-card--skeleton" />
        ))}
      </section>
    );
  }

  if (cards.length === 0) {
    return null;
  }

  return (
    <section className="stats-grid">
      {cards.map((card) => (
        <article key={card.title} className="stats-card">
          <div className="stats-top">
            <h3>{card.title}</h3>
            {card.progress && (
              <div className="stats-progress">
                <div style={{ width: card.progress }} />
              </div>
            )}
          </div>
          <div className="flex align-center justify-between gap-20">
            <p className="stats-value">{card.value}</p>
            {card.valueRight && <span className="stats-top-right">{card.valueRight}</span>}
          </div>
          <div className="stats-content">{(card.rows || []).map((row, index) => renderRow(row, index))}</div>
        </article>
      ))}
    </section>
  );
}

export default StatsGrid;
